import { name as root } from '../actionTypes';

export const name = `${root}/shippingorders`

export const FETCH_SHIPPING_ORDERS_REQUEST = `${name}/request`
export const FETCH_SHIPPING_ORDERS_SUCCESS = `${name}/success`
export const FETCH_SHIPPING_ORDERS_FAILURE = `${name}/failure`

export const SET_ACTIVE_SHIPPING_ORDER = `${name}/setactiveorder`
export const SET_PREVIOUS_SHIPPING_ORDER = `${name}/setpreviousorder`
export const SET_ACTIVE_TAB = `${name}/setactivetab`